<template>
  <div id="admin-property-view" class="property-view">
    <v-row no-gutters>
      <v-col md="12">
        <user-table />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";

export default {
  components: {
    UserTable: () => import("@/components/user/UserTable.vue")
  },
  created() {
    this.$emit(`update:layout`, DefaultLayout);
  }
};
</script>
